import { type } from "jquery"

const init = {
    ShowMenu: false,
    TabPrincipal: 0,
    Paginas: [],
    PaginaActual: null
}
export const PrincipalReducer = (state = init, action) => {
    switch (action.type) {
        case typesPrincipal.ShowMenu: return { ...state, ShowMenu: action.payload }
        case typesPrincipal.CambioTab: return { ...state, TabPrincipal: action.payload }
        case typesPrincipal.AbrirPaginaActual: return {
            ...state,
            PaginaActual: action.payload.PaginaActual,
            Paginas: action.payload.Paginas,
        }
        case typesPrincipal.ActualizarPaginas: return { ...state, Paginas: action.payload }
        case typesPrincipal.CerrarPrincipal: return init;
        default: return state;
    }
}
/* ### Actions ### */
export const ShowMenu = (show = true) => {
    return {
        type: typesPrincipal.ShowMenu,
        payload: show
    }
}
export const CambioTabPrincipal = (index) => {
    return { type: typesPrincipal.CambioTab, payload: index }
}
export const AbrirPaginaActual = (params) => {
    return { type: typesPrincipal.AbrirPaginaActual, payload: params }
}
export const ActualizarListaPaginas = (Paginas) => {
    return { type: typesPrincipal.ActualizarPaginas, payload: Paginas }
}
export const CerrarPrincipal = ()=>{
    return { type: typesPrincipal.CerrarPrincipal }
}
/* ### Actions ### */

/* ### Types de Inicio ### */
export const typesPrincipal = {
    ShowMenu: '[Principal] ShowMenu',
    CambioTab: '[Principal] CambioTab',
    AbrirPaginaActual: '[Principal] AbrirPaginaActual',
    ActualizarPaginas: '[Principal] ActualizarPaginas',
    CerrarPrincipal: '[Principal] CerrarPrincipal',
}
/* ### Types de Inicio ### */